import { render } from "./ProductDefault.vue?vue&type=template&id=133ea04a&scoped=true&ts=true"
import script from "./ProductDefault.vue?vue&type=script&lang=ts"
export * from "./ProductDefault.vue?vue&type=script&lang=ts"

import "./ProductDefault.vue?vue&type=style&index=0&id=133ea04a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133ea04a"]])

export default __exports__